import { Stack, Switch, Typography, styled, Radio, FormControlLabel } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { ManageEntityParametersModel } from "@store/entities/details";
import { TalentLinkAutomationEnum } from "@store/common/talentLinkAutomation.enum";

import { Colors } from "@constants/colors.constant";

export const RadioBtn = styled(Radio)({
  width: "15px",
  height: "15px",
  alignSelf: "center",
  marginRight: "5px",
  "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)": {
    color: Colors.primary,
    width: "15px",
    height: "15px",
  },
  "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
    color: Colors.primary,
    width: "15px",
    height: "15px",
  },
});

interface AccessToTalentLinkConfigComponentProps {
  isActivated?: boolean;
  updateParameters: Dispatch<SetStateAction<ManageEntityParametersModel>>;
  talentLinkAutomation?: TalentLinkAutomationEnum;
}

const AccessToTalentLinkConfigComponent = (props: AccessToTalentLinkConfigComponentProps) => {
  const { isActivated = false, updateParameters, talentLinkAutomation } = props;

  const { t } = useTranslation();

  const handleChangeTalentLinkAutomation = (value: TalentLinkAutomationEnum) => {
    updateParameters((state) => ({...state, talentLinkAutomation: value}));
  };

  return (
    <Stack position="relative" width="100%">
      <Stack flex={0.5} width="100%" p="25px" bgcolor={Colors.background} borderRadius="15px" spacing={2}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="calc(100% + 10px)">
          <Typography fontSize={16} fontWeight="700">
            {t("clients.details.parametersTab.accessToTalentLink.accessToTalentLink")}
          </Typography>
          <Switch 
            checked={isActivated}
            onChange={(_, checked) => 
              updateParameters((state) => ({...state, hasAccessToTalentLink: checked}))
            }
          />
        </Stack>
        {isActivated && (
          <Stack spacing={1}>
            <FormControlLabel 
              value={TalentLinkAutomationEnum.NO_AUTOMATION} 
              control={
                <RadioBtn 
                  id="noAutomation"
                  value={TalentLinkAutomationEnum.NO_AUTOMATION}
                  checked={talentLinkAutomation === TalentLinkAutomationEnum.NO_AUTOMATION} 
                  onChange={(_, checked) => handleChangeTalentLinkAutomation(checked ? TalentLinkAutomationEnum.NO_AUTOMATION : TalentLinkAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION)}
                />
              }
              label={
                <Typography fontSize={14} fontWeight="300">
                  {t("clients.details.parametersTab.accessToTalentLink.noAutomation")}
                </Typography>
              }
            />
            <FormControlLabel 
              value={TalentLinkAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION} 
              control={
                <RadioBtn 
                  id="automationOnApplicationCreation" 
                  value={TalentLinkAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION}
                  checked={talentLinkAutomation === TalentLinkAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION} 
                  onChange={(_, checked) => handleChangeTalentLinkAutomation(checked ? TalentLinkAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION : TalentLinkAutomationEnum.AUTOMATION_ON_APPLICATION_AI_EVALUATION)}
                />
              }
              label={
                <Typography fontSize={14} fontWeight="300">
                  {t("clients.details.parametersTab.accessToTalentLink.automationOnApplicationCreation")}
                </Typography>
              }
            />
            <FormControlLabel 
              value={TalentLinkAutomationEnum.AUTOMATION_ON_APPLICATION_AI_EVALUATION} 
              control={
                <RadioBtn 
                  id="automationOnApplicationAiEvaluation" 
                  value={TalentLinkAutomationEnum.AUTOMATION_ON_APPLICATION_AI_EVALUATION}
                  checked={talentLinkAutomation === TalentLinkAutomationEnum.AUTOMATION_ON_APPLICATION_AI_EVALUATION} 
                  onChange={(_, checked) => handleChangeTalentLinkAutomation(checked ? TalentLinkAutomationEnum.AUTOMATION_ON_APPLICATION_AI_EVALUATION : TalentLinkAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION)}
                />
              }
              label={
                <Typography fontSize={14} fontWeight="300" whiteSpace="nowrap">
                  {t("clients.details.parametersTab.accessToTalentLink.automationOnApplicationAiEvaluation")}
                </Typography>
              }
            />
          </Stack>
        )}
      </Stack>      
    </Stack>
  );
};

export default AccessToTalentLinkConfigComponent;
